/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown>, active: NonNullable<unknown>, expired: NonNullable<unknown> }} Partner_Commission_Customers_SummaryInputs */



/**
* | output |
* | --- |
* | "{total} total · {active} active · {expired} expired" |
*
* @param {Partner_Commission_Customers_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_commission_customers_summary = /** @type {((inputs: Partner_Commission_Customers_SummaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Commission_Customers_SummaryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.total} gesamt · ${i?.active} aktiv · ${i?.expired} abgelaufen`)
	return /** @type {LocalizedString} */ (`${i?.total} total · ${i?.active} active · ${i?.expired} expired`)
});